module.exports = __webpack_public_path__ + "static/media/information.53b1bea9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/Assets/img/information.svg
// module id = 1030
// module chunks = 0